import styled from 'styled-components';
import { margin } from '@10d/tend-ui-styling';

const Root = styled.table `
  ${margin};

  width: 100%;
  height: 100%;
  border-collapse: collapse;
`;

export { Root };
//# sourceMappingURL=styled.js.map
